import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, with later Tailwind utilities correctly overriding earlier
 * ones.
 *
 * Plain string concatenation produces `px-2 px-4`, where the winner depends on
 * CSS source order rather than on the caller's intent. `twMerge` resolves the
 * conflict properly, which is what makes component `className` overrides
 * predictable.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
